import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CatButton } from '@blocks-react/components/Button';
import FormField from '../FormField';
import { DEFAULT_ADDRESS_LIMIT } from '../constants';
import styles from '../AddressFormFields.module.scss';

const AddressLineField = ({
  isAddress2Required,
  showAddressLine2,
  isAddressRequiredFlag,
  addressLimit
}) => {
  const [t] = useTranslation();

  const [showAddress2, setShowAddress2] = useState(
    isAddress2Required || showAddressLine2
  );

  return (
    <>
      <div>
        <FormField
          fieldId="address1"
          required={isAddressRequiredFlag}
          label={t('CAT_EMAIL_ADDRESS_1')}
          maxLength={addressLimit ?? DEFAULT_ADDRESS_LIMIT}
        />

        {!showAddress2 && (
          <CatButton
            data-testid="cat-button"
            variant="ghost"
            onClick={() => setShowAddress2(true)}
            size="sm"
            className={styles['address-form-fields__add-address-line']}
          >
            {t('ADD_ADDRESS_LINE_2')}
          </CatButton>
        )}
      </div>

      {showAddress2 && (
        <FormField
          fieldId="address2"
          required={isAddress2Required}
          label={t('CAT_EMAIL_ADDRESS_2')}
          maxLength={addressLimit ?? DEFAULT_ADDRESS_LIMIT}
        />
      )}
    </>
  );
};

AddressLineField.propTypes = {
  isAddress2Required: PropTypes.bool,
  showAddressLine2: PropTypes.bool,
  isAddressRequiredFlag: PropTypes.bool,
  addressLimit: PropTypes.string
};

export default AddressLineField;
